/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientCondition from './patient-condition';
import PatientConditionDetail from './patient-condition-detail';
import PatientConditionUpdate from './patient-condition-update';
import PatientConditionDeleteDialog from './patient-condition-delete-dialog';

const PatientConditionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientCondition />} />
    <Route path="new" element={<PatientConditionUpdate />} />
    <Route path=":id">
      <Route index element={<PatientConditionDetail />} />
      <Route path="edit" element={<PatientConditionUpdate />} />
      <Route path="delete" element={<PatientConditionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientConditionRoutes;
